define('ordersDetailOrderProductAlternativesView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'ordersDetailOrderProductAlternativesItemView',
  'template!ordersDetailOrderProductAlternativesView'
], function (
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  ItemView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    childView: ItemView,
    className: 'orders-detail-order-product-alternatives-view',
    childViewContainer: '.alternatives-items',

    childViewOptions: function () {
      return {
        orderModel: this.model,
        product: this.options.product
      };
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    modelEvents: {
      'change:productSecId': 'onRender',
      'change:productJson': 'onRender'
    },

    onRender: function () {
      this.collection.reset();
      this.$el.hide();

      if (!this.options.product.get('pim')) return;

      this.fetchAlternatives();
    },

    fetchAlternatives: function () {
      var productSecId = this.options.product.get('secId');
      if (!productSecId) return;

      var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + productSecId + '/alternatives/');

      $.ajax({
        type: 'GET',
        url: url,
        success: _.bind(function (data) {
          if (this.isDestroyed) return;
          if (data && data.length > 0) {
            this.$el.show();
            this.$('.badge-count').text(data.length);
            this.collection.reset(data);
          }
        }, this),
        error: _.bind(function () {
          if (this.isDestroyed) return;
        }, this)
      });
    }
  });
});
